import React, { useEffect, useState } from 'react';

// Translation
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { addMaterialSlice, addMaterialState,iSelection ,addMaterialFields} from './AddModalSlice';

import { materialsSlice } from '../MaterialsSlice';

// Components
import Modal from '../../../components/Modal/Modal';
import {
  InputField,
  Switcher,
} from '../../../components/FormElements/FormElements';
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader';
import AutoComplete from '../../../AutoComplete/AutoComplete';
import { useFormik } from 'formik';

import { useAPI } from '../../../services/hoc/useAPI';

export default () => {
  // Translation
  const t = useTranslation();
const formik=useFormik<addMaterialFields>({
  initialValues:{},
  onSubmit:()=>{}
})
  // Redux
  const dispatch = useDispatch();
 const  [request,setRequest]=useState<{isFetching:boolean,isLoaded:boolean}>({isFetching:false,isLoaded:false})
  const state = useSelector(
    (state: { add_material: addMaterialState }) => state.add_material,
  );


  const ENDPOINTS = useAPI()

  // Hooks
  const [showErrors, setShowErrors] = useState<boolean>(false);

  // Add material
  const add = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (formik.values.name === '' || formik.values.serial_number === ''
    ) {
      setShowErrors(true);
      return;
    }

    dispatch(addMaterialSlice.actions.setIsLoading(true));

    const endpoint = state.editId
      ? ENDPOINTS.glasses().update
      : ENDPOINTS.glasses().store;

    endpoint({
      id: state.editId,
      name: formik.values.name || '',
      code: formik.values.serial_number || '',
      is_priced:formik.values.is_priced || false,
      // description: state.fields.description || "",
      // attributes_list: state.fields.attributes || []
    }).then((response: any) => {
      dispatch(addMaterialSlice.actions.setIsSuccess(true));
      setTimeout(() => {
        toggle();
        // dispatch(
        //   materialsSlice.actions.addMaterials([
        //     {
        //       id: response.data.data.id,
        //       name: response.data.data.name,
        //       description: response.data.data.description,
        //       code: response.data.data.code,
        //     },
        //   ]),
        // );
        if (response.data.data.id ){
         if (state.editId){
              dispatch(
                      materialsSlice.actions.updateMaterial(
                        {
                          id: response.data.data.id,
                          name: response.data.data.name,
                          description: response.data.data.description,
                          code: response.data.data.code,
                        },
                      ),
                    );
         }
         else {
          dispatch(materialsSlice.actions.addMaterials([
            {
              id: response.data.data.id,
               name: response.data.data.name,
               description: response.data.data.description,
               code: response.data.data.code,
            }
          ]))
           dispatch(materialsSlice.actions.setMaterial({ 
             showMaterial:true,
             material:{
 
               id: response.data.data.id,
               name: response.data.data.name,
               description: response.data.data.description,
               code: response.data.data.code,
             } 
           }))
         }
        }
        // dispatch(showMaterialSlice.actions.setIsOpen({ id: response.data.data.id, isOpen: true }))
      }, 1000);
    });
  };
  // const ENDPOINTS = new API()

  const fetchData = () => {

      ENDPOINTS.glasses().index({ page: 1, page_size: 1000 })
          .then((response: any) => {
           
              let list:iSelection[] = response.data.data.glasses.map((component: any) => 
              ({ id: component.id, label: component.name }))
              dispatch(addMaterialSlice.actions.setList(list))
              setRequest(pre=>({isFetching:false,isLoaded:true}))
          })
          .catch((err:any)=>   setRequest(pre=>({isFetching:false,isLoaded:false})))

  }
const handleAddMaterialChange=(value:iSelection)=>{
  //dispatch(addMaterialSlice.actions.set({selection:{value:1001,label:value.label}}))
  //dispatch(addMaterialSlice.actions.setItem({...value,value:1001}))
  formik.setFieldValue('name',value.label)

}
  const toggle = () => {
    dispatch(addMaterialSlice.actions.setIsOpen(!state.isOpen));
    dispatch(addMaterialSlice.actions.init());
  };
  useEffect(()=>{
    if (state.editId) {
      formik.resetForm({values:{...state.fields}})
    }
  },[state])

  return (
    <Modal open={state.isOpen} toggle={toggle}>
      {state.isLoading ? <WhiteboxLoader /> : ''}

      {state.isSuccess ? <SuccessMark /> : ''}

      <h2 className="text-center" style={{ margin: '0 0 20px' }}>
        {state.editId ? t('edit_material') : t('add_to_materials')}
      </h2>

      <form onSubmit={add} style={{ width: 400, maxWidth: '100%' }}>
        {/* <InputField
          label={t('material_name') + ' *'}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            dispatch(addMaterialSlice.actions.set({ name: e.target.value }))
          }
          value={state.fields.name}
          error={
            showErrors && state.fields.name === '' ? t('required_error') : ''
          }
        /> */}
        <AutoComplete 
      label={t('material_name') + ' *'}
      fetchData={fetchData}
      isLoaded={request.isLoaded}
      onChange={(e:React.ChangeEvent<HTMLInputElement>)=>{
        handleAddMaterialChange({id:1001,label:e.target.value})
      }}
      isLoading={request.isFetching}
      options={state.materialsList}
      value={formik.values.name}
        />

        <InputField
          label={t('serial_number') + ' *'}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            formik.setFieldValue('serial_number',e.target.value)
            // dispatch(
            //   addMaterialSlice.actions.set({ serial_number: e.target.value }),
            // )
          }
          value={formik.values.serial_number}
          error={
            showErrors && state.fields.serial_number === ''
              ? t('required_error')
              : ''
          }
          max={10}
        />
        <Switcher
          first_choice={t('Priced')}
          second_choice={t('NotPriced')}
          handleChange={(value: boolean) =>
            formik.setFieldValue('is_priced',value?1:0)

            //dispatch(addMaterialSlice.actions.set({is_priced:value?1:0}))
          }
          value={formik.values.is_priced===1 || false}
        />
        {/* <CustomCheckbox label={t('is_priced')}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addMaterialSlice.actions.set({ is_priced: e.target.value === 'true' }))}
                    value={state.fields.is_priced} /> */}

        <button
          className="button round bg-gold color-white margin-top-30"
          style={{ padding: '0 80px', marginBottom: 5 }}>
          {t('submit')}
        </button>
      </form>
    </Modal>
  );
};
